import api from "../../services/api";
import {
  GET_ESTIMATED_PRICE_FAILURE,
  GET_ESTIMATED_PRICE_FILTERED_FAILURE,
  GET_ESTIMATED_PRICE_FILTERED_REQUEST,
  GET_ESTIMATED_PRICE_FILTERED_SUCCESS,
  GET_ESTIMATED_PRICE_REQUEST,
  GET_ESTIMATED_PRICE_SUCCESS,
  UPDATE_ESTIMATED_PRICE_FAILURE,
  UPDATE_ESTIMATED_PRICE_REQUEST,
  UPDATE_ESTIMATED_PRICE_SUCCESS,
} from "./ActionType";

const getEstimatedPriceRequest = () => ({
  type: GET_ESTIMATED_PRICE_REQUEST,
});

const getEstimatedPriceSuccess = (estimatedPrice) => ({
  type: GET_ESTIMATED_PRICE_SUCCESS,
  payload: estimatedPrice,
});

const getEstimatedPriceFailure = (error) => ({
  type: GET_ESTIMATED_PRICE_FAILURE,
  payload: error,
});

export const getEstimatedPriceList = (cityId, dayId) => async (dispatch) => {
  dispatch(getEstimatedPriceRequest());
  try {
    const response = await api.get(
      `/price/estimated-price?cityId=${cityId}&dayId=${dayId}`,
      {
        withCredentials: true,
      }
    );
    dispatch(getEstimatedPriceSuccess(response.data));
  } catch (error) {
    dispatch(getEstimatedPriceFailure(error));
  }
};

const updateEstimatedPriceRequest = () => ({
  type: UPDATE_ESTIMATED_PRICE_REQUEST,
});

const updateEstimatedPriceSuccess = (estimatedPrice) => ({
  type: UPDATE_ESTIMATED_PRICE_SUCCESS,
  payload: estimatedPrice,
});

const updateEstimatedPriceFailure = (error) => ({
  type: UPDATE_ESTIMATED_PRICE_FAILURE,
  payload: error,
});

export const updateEstimatedPrice = (request) => async (dispatch) => {
  dispatch(updateEstimatedPriceRequest());
  try {
    const response = await api.put(
      `/price/estimated-price?estimatedPriceId=` + request.id,
      request,
      {
        withCredentials: true,
      }
    );
    dispatch(updateEstimatedPriceSuccess(response.data));
  } catch (error) {
    dispatch(updateEstimatedPriceFailure(error));
  }
};

const getEstimatedPriceFilteredRequest = () => ({
  type: GET_ESTIMATED_PRICE_FILTERED_REQUEST,
});

const getEstimatedPriceFilteredSuccess = (estimatedPrice) => ({
  type: GET_ESTIMATED_PRICE_FILTERED_SUCCESS,
  payload: estimatedPrice,
});

const getEstimatedPriceFilteredFailure = (error) => ({
  type: GET_ESTIMATED_PRICE_FILTERED_FAILURE,
  payload: error,
});

export const getEstimatedPriceFiltered =
  (vehicle, dayId, washType, seater) => async (dispatch) => {
    dispatch(getEstimatedPriceFilteredRequest());
    try {
      const response = await api.get(
        `/price/estimated-price-filtered?vehicle=${vehicle}&dayId=${dayId}&washType=${washType}&seater=${seater}`,
        {
          withCredentials: true,
        }
      );
      dispatch(getEstimatedPriceFilteredSuccess(response.data));
    } catch (error) {
      dispatch(getEstimatedPriceFilteredFailure(error));
    }
  };
